import {
  getEmailLearningCenter,
  getEmailServiceInquiries,
  getEmailSalesInquiries,
  getEmailFutureScholar,
} from '../../../global/environments/config'

const AskSpecialistEmailRecipient = {
  LC_email: {
    recipientEmail: getEmailLearningCenter(),
    subject: 'Learning Center Email Inquiry',
    type: 'Ask a Specialist',
    subHeading:
      'Have a client-specific challenge you’re struggling to solve? Submit your question below, or for immediate help, contact your wholesaler to speak directly with an ERISA specialist.',
    disclosure:
      'The Resource Desk is staffed by the Retirement Learning Center, LLC, a third-party industry consultant that is not affiliated with Columbia Threadneedle Investments. Any information provided is for informational purposes only. Please consult a tax advisor or attorney for specific tax or legal needs.',
  },
  aqa: {
    recipientEmail: getEmailLearningCenter(),
    subject: 'Learning Center Email Inquiry',
    type: 'Ask a Specialist',
    subHeading:
      'Have a client-specific challenge you’re struggling to solve? Submit your question below, or for immediate help, contact your wholesaler to speak directly with an ERISA specialist.',
    disclosure:
      'The Resource Desk is staffed by the Retirement Learning Center, LLC, a third-party industry consultant that is not affiliated with Columbia Threadneedle Investments. Any information provided is for informational purposes only. Please consult a tax advisor or attorney for specific tax or legal needs.',
  },
}

const EmailContactRecipients = {
  default: {
    recipientEmail: getEmailServiceInquiries(),
    subject: 'Contacting for Help',
    type: 'Contact Us By Email',
    subHeading: '',
    disclosure: '',
  },
  service_inquiries: {
    recipientEmail: getEmailServiceInquiries(),
    subject: 'Contacting for Help',
    type: 'Service Inquiries',
    subHeading: '',
    disclosure: '',
  },
  product_inquiries: {
    recipientEmail: getEmailSalesInquiries(),
    subject: 'Contacting for Help',
    type: 'Product Inquiries',
    subHeading: '',
    disclosure: '',
  },
  sales_inquiries: {
    recipientEmail: getEmailSalesInquiries(),
    subject: 'Contacting for Help',
    type: 'Sales/Prospecting Questions',
    subHeading: '',
    disclosure: '',
  },
  '529FS_inquiries': {
    recipientEmail: getEmailFutureScholar(),
    subject: 'Contacting for Help',
    type: '529 Plan Service Inquiries',
    subHeading: '',
    disclosure: '',
  },
}

export { AskSpecialistEmailRecipient, EmailContactRecipients }
